import axios from 'axios';
import Cookies from 'js-cookie';
import { API_BASE_URL } from '../../config/site';

const API_ORIGIN = API_BASE_URL.replace(/\/api\/?$/, '');

const axiosClient = axios.create({
    baseURL: API_BASE_URL,
    withCredentials: true,
    headers: {
        Accept: 'application/json',
        'X-Requested-With': 'XMLHttpRequest',
    },
});

axiosClient.interceptors.request.use((config) => {
    const token = localStorage.getItem('ACCESS_TOKEN');
    if (token) {
        config.headers.Authorization = `Bearer ${token}`;
    } else {
        delete config.headers.Authorization;
    }

    const xsrfToken = Cookies.get('XSRF-TOKEN');
    if (xsrfToken) {
        config.headers['X-XSRF-TOKEN'] = xsrfToken;
    }

    if (!(config.data instanceof FormData)) {
        config.headers['Content-Type'] = 'application/json';
    }

    return config;
});

let handleError;
export const setHandleError = (fn) => {
    handleError = fn;
};

axiosClient.interceptors.response.use(
    (response) => response,
    async (error) => {
        const { response, config } = error;

        if (response?.status === 419 && config && !config._csrfRetried) {
            config._csrfRetried = true;
            try {
                await getCsrfToken();
                return axiosClient(config);
            } catch {
                // Laisser l'erreur 419 remonter si le renouvellement CSRF échoue.
            }
        }

        if (handleError) {
            if (!response) {
                handleError('Erreur réseau : vérifiez votre connexion Internet.');
            } else if (response.status === 401) {
                const isLoginRequest = String(error.config?.url || '').includes('/organizer/login');
                if (!isLoginRequest) {
                    handleError('Session expirée. Veuillez vous reconnecter.');
                    localStorage.removeItem('ACCESS_TOKEN');
                    if (!window.location.pathname.startsWith('/login')) {
                        window.location.href = '/login';
                    }
                }
            } else if (response.status === 419) {
                handleError('Session expirée. Rechargez la page puis réessayez.');
            }
        }

        return Promise.reject(error);
    },
);

/** Optionnel — le login organisateur utilise Bearer Sanctum, pas le cookie CSRF. */
export const getCsrfToken = () =>
    axios.get(`${API_ORIGIN}/sanctum/csrf-cookie`, {
        withCredentials: true,
        headers: {
            Accept: 'application/json',
            'X-Requested-With': 'XMLHttpRequest',
        },
    });

export default axiosClient;
